import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 年間売上実績の検索
 */
export function searchAnnualSalesPerformData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchAnnualSalesPerformData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 年間売上実績データの更新
 */
export function updateAnnualSalesPerformData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateAnnualSalesPerformData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 「月間売上実績」echartsデータの検索
 */
export function getMonthSalesEChartData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetMonthSalesEChartData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
